var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomCardArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.801,
    height: 10.643,
    viewBox: "0 0 14.801 10.643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8699",
    "data-name": "Group 8699",
    transform: "translate(0.25 0.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24941",
    "data-name": "Path 24941",
    d: "M9.627.183a.509.509,0,1,0-.781.652A.514.514,0,0,0,8.911.9l3.655,3.66H.484a.51.51,0,0,0,0,1.019H12.566L8.905,9.234a.519.519,0,0,0,0,.716.506.506,0,0,0,.715,0h0L14.15,5.422a.5.5,0,0,0,.013-.7l-.013-.013Z",
    transform: "translate(-0.001 -0.001)",
    fill: "#5b6a85",
    stroke: "#5b6a85",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomCardArrow);
export default __webpack_public_path__ + "static/media/customCardArrow.6cf626604d074a910a9d35b155f80554.svg";
export { ForwardRef as ReactComponent };